<template>
  <div class="h-100 d-block overflow-scroll">
    <b-table
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      small
      :fields="fields"
      :items="dataList"
    >
      <template #cell(csi_sales)="data">
        {{ data.item.csi_sales | toNumber }}
      </template>
      <template #cell(csi_sales_rates)="data">
        % {{ data.item.csi_sales_rates | toNumber }}
      </template>
      <template #cell(csi_services)="data">
        {{ data.item.csi_services | toNumber }}
      </template>
      <template #cell(csi_services_rates)="data">
        % {{ data.item.csi_services_rates | toNumber }}
      </template>
      <template #cell(google_score)="data">
        {{ data.item.google_score | toNumber }}
      </template>
      <template #custom-foot>
        <b-tr>
          <b-th class="font-small-1">
            G. Toplam
          </b-th>
          <b-th class="text-right font-small-2">
            {{ grandTotals.csi_sales | toNumber }}
          </b-th>
          <b-th class="text-right font-small-2">
            {{ grandTotals.csi_sales_rates | toNumber }}
          </b-th>
          <b-th class="text-right font-small-2">
            {{ grandTotals.csi_services | toNumber }}
          </b-th>
          <b-th class="text-right font-small-2">
            {{ grandTotals.csi_services_rates | toNumber }}
          </b-th>
          <b-th class="text-right font-small-2">
            {{ grandTotals.google_score | toNumber }}
          </b-th>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>
<script>
import {
  BTable, BTh, BTr,
} from 'bootstrap-vue'

export default {
  name: 'TablePerformance',
  components: {
    BTr,
    BTh,
    BTable,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    grandTotals: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Marka',
          sortable: true,
          thClass: 'font-small-1 align-middle text-nowrap',
          tdClass: 'font-small-2 font-weight-bold text-body',
        },
        {
          key: 'csi_sales',
          label: 'CSI Satış',
          sortable: true,
          thClass: 'font-small-1 text-right align-middle',
          tdClass: 'font-small-2 text-right text-body',
        },
        {
          key: 'csi_sales_rates',
          label: 'CSI Satış Değişim %',
          sortable: true,
          thClass: 'font-small-1 text-right align-middle',
          tdClass: 'font-small-2 text-right text-nowrap text-body',
        },
        {
          key: 'csi_services',
          label: 'CSI Servis',
          sortable: true,
          thClass: 'font-small-1 text-right align-middle',
          tdClass: 'font-small-2 text-right text-nowrap text-body',
        },
        {
          key: 'csi_services_rates',
          label: 'CSI Servis Değişim %',
          sortable: true,
          thClass: 'font-small-1 text-right align-middle',
          tdClass: 'font-small-2 text-right text-nowrap text-body',
        },
        {
          key: 'google_score',
          label: 'Google Skor',
          sortable: true,
          thClass: 'font-small-1 text-right align-middle',
          tdClass: 'font-small-2 text-right text-nowrap text-body',
        },
      ],
    }
  },
}
</script>
